import { ENDPOINTS } from "@/constants/api/endpoints";
import { useApiQuery } from "../../hooks/use-api-query";
import { queryKeys } from "../../query-keys";
import { AccommodationTypeResponse } from "@/types/accommodationType";

export const useAccommodationTypes = () => {
  return useApiQuery<AccommodationTypeResponse>(
    queryKeys.references.accommodationTypes,
    ENDPOINTS.REFERENCES.ACCOMMODATION_TYPES,
    {},
    {
      staleTime: 30 * 60 * 1000, // 30 minutes - accommodation types don't change frequently
      gcTime: 60 * 60 * 1000, // 1 hour
      refetchOnMount: false, // Use prefetched data, don't refetch on mount
      refetchOnWindowFocus: false, // Don't refetch on window focus for reference data
    }
  );
};
